// @flow

import * as React from 'react';
import Box from 'sail/Box';
import Card from 'sail/Card';
import Notice from 'sail/Notice';
import './Callout.scss';

type CalloutProps = {|
  type: 'caution' | 'check' | 'note' | 'warning',
  title?: string,
  id?: string,
  children?: React.Node,
|};

const TYPE_PROPS = {
  caution: {icon: 'warning', color: 'yellow'},
  check: {icon: 'checkmark', color: 'green'},
  note: {icon: 'info', color: 'offset'},
  warning: {icon: 'warning', color: 'red'},
};

export const Callout = ({title, type, id, children}: CalloutProps) => {
  const typeProps = TYPE_PROPS[type];

  return (
    <Box className="CalloutWrapper" padding={{top: 20, bottom: 12}} id={id}>
      <Card className="Callout" shadow="keyline">
        <Notice
          title={title}
          description={children}
          divider={false}
          {...typeProps}
        />
      </Card>
    </Box>
  );
};
